import { render } from "./SettingsManage.vue?vue&type=template&id=9a0af08c"
import script from "./SettingsManage.vue?vue&type=script&lang=js"
export * from "./SettingsManage.vue?vue&type=script&lang=js"

import "./SettingsManage.vue?vue&type=style&index=0&id=9a0af08c&lang=less"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__